// MCM-1093 Added new class for Guid Empty
export class Guid{
    public static readonly EMPTY:string = "00000000-0000-0000-0000-000000000000";
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/guid.ts